// extracted by mini-css-extract-plugin
module.exports = {"link":"woo-link_link__S0Qzz","text":"woo-link_text__ZisZO","title":"woo-link_title__tyyQ3","description":"woo-link_description__QpqfM"};